import React from 'react';
import { SmallBody } from '@indigo-ag/component-module';

import i18next from 'core/i18n';

export const StartAnalysisPhase2Disclaimer: React.FunctionComponent = () => {
  return (
    <div style={{ margin: 0, padding: 0, paddingLeft: 20 }}>
      <SmallBody>{i18next.t('startNoMatricula')}</SmallBody>
    </div>
  );
};
